import sample_01 from './100_47747.jpg';

export const dynamicElementsPlusImpressions = {
    sample_01,
};
